import { render, staticRenderFns } from "./smsAnalysis.vue?vue&type=template&id=4c53654a&scoped=true"
import script from "./smsAnalysis.vue?vue&type=script&lang=js"
export * from "./smsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./smsAnalysis.vue?vue&type=style&index=0&id=4c53654a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c53654a",
  null
  
)

export default component.exports